import React, { Component } from "react";
import PropTypes from "prop-types";
import { GridColumn } from "arv-reactcomponents";
import PriceBlock from "../../ProductList/PriceBlock";

class ProductPriceBlock extends Component {
  get priceBlockDetails() {
    const { product } = this.props;
    return {
      selectedSku: {
        mrp: product.totalMRP || product.mrp,
        price: product.totalGrossSP || product.totalMRP,
        discountInPercentage: product.discountInPercentage,
        skuId: product.skuId,
      },
    };
  }
  render() {
    const { currentView } = this.props;
    return (
      <GridColumn
        className={`nwc-grid-col-sm-${
          currentView === "mybag" ? "4" : "12"
        } nw-cartproductview-price ${currentView}`}
      >
        <PriceBlock.component
          {...this.priceBlockDetails}
          className="nw-cartproductview-pricetext"
        />
      </GridColumn>
    );
  }
}

ProductPriceBlock.propTypes = {
  product: PropTypes.shape({}).isRequired,
  currentView: PropTypes.string.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ProductPriceBlock,
  component: ProductPriceBlock,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CartProducts/ProductPriceBlock/index.js